import { render } from "./SectionTechFrontChat.vue?vue&type=template&id=71aa1802&scoped=true"
import script from "./SectionTechFrontChat.vue?vue&type=script&lang=js"
export * from "./SectionTechFrontChat.vue?vue&type=script&lang=js"

import "./SectionTechFrontChat.vue?vue&type=style&index=0&id=71aa1802&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aa1802"]])

export default __exports__